// Per-history-entry navigation state, so pressing Back returns the user to where
// they were (scroll position, drawer position, list depth, selected category)
// instead of rebuilding the previous page. Keyed by React Router's location.key
// (unique + stable per history entry), persisted in sessionStorage so it also
// survives the WebView reloading a page during a back navigation.
const KEY = "rr_nav_state";

function readAll() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
}

function writeAll(obj) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(obj));
  } catch {
    /* ignore quota / privacy-mode errors */
  }
}

export function getNavState(key) {
  if (!key) return null;
  return readAll()[key] || null;
}

export function saveNavState(key, patch) {
  if (!key || !patch) return;
  const all = readAll();
  all[key] = { ...(all[key] || {}), ...patch };
  writeAll(all);
}
